import React, { createContext, ReactNode, useContext, useState } from 'react'

interface SignUpVisibilityContextType {
  isSignUpButtonsIntersecting: boolean
  showTopbarSignUpButton: () => void
  hideTopbarSignUpButton: () => void
}

const initial: SignUpVisibilityContextType = {
  isSignUpButtonsIntersecting: true,
  showTopbarSignUpButton: () => {},
  hideTopbarSignUpButton: () => {},
}

const SignUpVisibilityContext = createContext<SignUpVisibilityContextType | undefined>(initial)

const SignUpVisibilityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSignUpButtonsIntersecting, setIsSignUpButtonsIntersecting] = useState(true)

  const showTopbarSignUpButton = () => {
    if (isSignUpButtonsIntersecting) setIsSignUpButtonsIntersecting(false)
  }
  const hideTopbarSignUpButton = () => {
    if (!isSignUpButtonsIntersecting) setIsSignUpButtonsIntersecting(true)
  }

  return (
    <SignUpVisibilityContext.Provider
      value={{ isSignUpButtonsIntersecting, showTopbarSignUpButton, hideTopbarSignUpButton }}
    >
      {children}
    </SignUpVisibilityContext.Provider>
  )
}

const useSignUpVisibility = () => {
  const context = useContext(SignUpVisibilityContext)
  if (context === undefined) {
    throw new Error('useSignUpVisibility must be used within a SignUpVisibilityProvider')
  }
  return context
}

export { SignUpVisibilityProvider, useSignUpVisibility }
